import React from "react";

import HeaderRegistration from "../headerRegistration/HeaderRegistration";
import { t } from "i18next";
import { Button, Stack } from "react-bootstrap";
import GoBack from "../goBack/GoBack";
import MandatoryInputAsterisk from "../../../../components/mandatoryInputAsterisk/MandatoryInputAsterisk";
import { Trans } from "react-i18next";

const Step3 = ({ admin, setAdmin, nextStep, previousStep }) => {
  const handleClick = (value) => {
    setAdmin(value);
    nextStep();
  };

  return (
    <Stack
      gap={5}
      className="w-100 d-flex justify-content-center align-items-center py-5"
    >
      <Stack
        className="input-registration-wrapper w-100 d-flex justify-content-center align-items-center"
        gap={3}
      >
        <HeaderRegistration
          title={t("registration.do_you_have_association")}
          subtitle={t("registration.create_page_association")}
        />
        <Button
          variant="light"
          id={admin ? "selected-button" : ""}
          size="md"
          style={{ width: 310 }}
          onClick={() => handleClick(true)}
        >
          {t("common.yes")} <MandatoryInputAsterisk />
        </Button>
        <Button
          variant="light"
          size="md"
          id={!admin ? "selected-button" : ""}
          style={{ width: 310 }}
          onClick={() => handleClick(false)}
        >
          {t("registration.not_have_association")}
        </Button>

        <div className="field-constraints mt-3" style={{ width: 310 }}>
          <p>
            <Trans
              i18nKey="registration.constraints_yes_or_no_have_association"
              components={{ bold: <strong /> }}
            />
          </p>
        </div>
      </Stack>
      <GoBack previousStep={previousStep} />
    </Stack>
  );
};

export default Step3;
